export const STATUS_CIBIO = {
    EmPreenchimento: 1,
    EmAnalisePeloRegulatorio: 2,
    CorrecaoSolicitada: 3,
    EmCorrecao: 4,
    AprovadopeloRegulatorio: 5,
    Concluido: 6,
    Cancelado: 7
}